import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import App from "./App/App";
import { Provider } from "react-redux";

import reduxStore from "./App/redux_store";
import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "./reportWebVitals";
import Loader from "./App/Components/Loader/Loader";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";
import "react-datetime/css/react-datetime.css";
import "./assets/css/demo.css";
import SimpleReactLightbox from "simple-react-lightbox";
import * as serviceWorker from "./serviceWorkerRegistration";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import updateSWSafe from "./updateSWSafe";
const log = () => console.log("Controller loaded");
Sentry.init({
  dsn: "https://f2c91bdd31334fb1bd4d7a877982afe1@o1137442.ingest.sentry.io/6190075",
  integrations: [new BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <Provider store={reduxStore.store}>
    <PersistGate loading={<Loader />} persistor={reduxStore.persistor}>
      <SimpleReactLightbox>
        <App />
      </SimpleReactLightbox>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

const configuration = {
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      updateSWSafe(registration, { type: "SKIP_WAITING" }, log).catch(
        (error) => {
          // Rethrow error into React rendering stack
          throw error;
        }
      );
    }
  },
};
serviceWorker.register(configuration);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
